import { render, staticRenderFns } from "./customer-header.vue?vue&type=template&id=2b2a0046&scoped=true&"
import script from "./customer-header.vue?vue&type=script&lang=ts&"
export * from "./customer-header.vue?vue&type=script&lang=ts&"
import style0 from "./customer-header.vue?vue&type=style&index=0&id=2b2a0046&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a0046",
  null
  
)

export default component.exports